var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobsEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.774,
    height: 22.774,
    viewBox: "0 0 22.774 22.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M11.387,0A11.387,11.387,0,1,1,0,11.387,11.387,11.387,0,0,1,11.387,0Z",
    fill: "#f3f3f3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_87_1",
    "data-name": "Component 87 \\u2013 1",
    transform: "translate(2.387 2.387)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 18,
    height: 18,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_mode_edit_24px",
    d: "M3,10.61v2H5L10.91,6.706l-2-2Zm9.459-5.453a.532.532,0,0,0,0-.753l-1.25-1.25a.532.532,0,0,0-.753,0l-.977.977,2,2,.977-.977Z",
    transform: "translate(1 1.002)",
    fill: "#7e7e7e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsEditIcon);
export default __webpack_public_path__ + "static/media/jobs-edit-icon.339a73310a89056bcc6e5eea99eb70cb.svg";
export { ForwardRef as ReactComponent };